// extracted by mini-css-extract-plugin
export default {"faqBox":"styles_faqBox__6z20F","faqHeader":"styles_faqHeader__jZcL9","faqBody":"styles_faqBody__phU7W","activeFaq":"styles_activeFaq__Nstn0"};